<h1 class="matp-page-title">デバイス一覧</h1>
    <div class="matp-table-actions-area">
      <div class="tw-min-w-80 tw-mr-4 ">
      <mat-form-field appearance="outline" floatLabel="always" class ="tw-w-80">
        <mat-label>テナント名</mat-label>
        <mat-select 
        [(ngModel)]="tenantId"
        >
          <mat-option [value]="null"></mat-option>
          @for(tenant of tenantList; track tenant.tenantId) {
          <mat-option [value]="tenant.tenantId">
            {{ tenant.tenantName }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      </div>
    
      <div [formGroup]="contractFormGroup" class="tw-mb-2 tw-w-[500px]">
        <div class="tw-flex tw-space-x-4 tw-items-center">
          <mat-form-field appearance="fill" class="tw-flex-1" (click)="startDatePicker.open()">
            <mat-label>契約期間（開始）</mat-label>
            <input 
            matInput [matDatepicker]="startDatePicker"
            placeholder="YYYY/MM/DD"
            formControlName="contractStartedAt"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
          <span class="tw-mx-2">~</span>
          <mat-form-field appearance="fill" class="tw-flex-1" (click)="endDatePicker.open()">
            <mat-label>契約期間（終了）</mat-label>
            <input
            matInput
            [matDatepicker]="endDatePicker"
            placeholder="YYYY/MM/DD"
            formControlName="contractExpiredAt"
            />
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
    
          <button 
            mat-raised-button 
            id="search-btn" 
            class="tw-text-lg tw-mx-2" 
            color="primary" 
            (click)="initDeviceList()" 
            [disabled]="contractFormGroup.invalid || isSearchItemsEmpty()"
            >
            <mat-icon>search</mat-icon>
            <span>検索</span>
          </button>
        </div>
        <div class="tw-text-xs">
          @if (contractFormGroup.errors?.["dateRange"]) {
          <mat-error>開始日は終了日よりも前の日を指定してください。</mat-error>
          }
          @if (isSearchItemsEmpty()) {
          <mat-error>テナント名、対象期間のいずれかは指定してください</mat-error>
          }
        </div>
      </div>
    </div>

<!-- デバイス一覧 -->
<mat-card class="matp-card">
  <app-device-list-table
    [deviceList]="deviceList"
    [tenantList]="tenantList"
    [deviceTypeList]="deviceTypeList"
    [deviceTypeDisplayNames]="deviceTypeDisplayNames"
    [selection]="selection"
    (displayFlag)="displayFlag"
    (confirmed)="openUnaddedDeviceDialog()"
    (created)="openDeviceEditDialog()"
    (imported)="openDeviceImportDialog()"
    (updated)="openDeviceEditDialog($event)"
    (deleted)="deleteDevice($event)"
  ></app-device-list-table>
</mat-card>
